import { Button, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useHistory, useParams } from "react-router-dom"

interface IConfirmationParams {
  ticketNbr: string
  vrm: string
}

export const Confirmation: React.FC = () => {
  let { ticketNbr, vrm } = useParams<IConfirmationParams>()
  const history = useHistory()
  const goToMainPage = () => {
    history.push('/')
  }

  if (!ticketNbr || !vrm) {
    return (
      <Stack spacing={2} alignItems={"center"}>
        <Typography variant="h4">There was an error after the payment was processed, please review your email that you have got a receipt for the transaction.</Typography>
      </Stack>
    )
  }
  return (
    <Grid container display={'flex'} justifyContent='center'>
      <Stack spacing={4} alignItems={"center"} width='100%'>
        <Typography variant="h4" textAlign={'center'}>Payment for Breach ID {ticketNbr} (vehicle registration {vrm}) has been processed.</Typography>
        <Typography variant="h5" textAlign={'center'}>If the payment was successfully processed, you will receive a receipt via email.</Typography>
        <Button variant='contained' onClick={goToMainPage}>
          Back to home page
        </Button>
      </Stack>
    </Grid>
  )
}